// extracted by mini-css-extract-plugin
export default {"app":"app_app__ZSdIq","main":"app_main__nXLxf"};